/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const AndroidShare = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21 6C21 7.38071 19.8807 8.5 18.5 8.5C17.7501 8.5 17.0774 8.16985 16.6191 7.64698L7.94255 11.4647C7.98018 11.6371 8 11.8163 8 12C8 12.1838 7.98018 12.3629 7.94255 12.5353L16.6191 16.353C17.0773 15.8302 17.7501 15.5 18.5 15.5C19.8807 15.5 21 16.6193 21 18C21 19.3807 19.8807 20.5 18.5 20.5C17.1193 20.5 16 19.3807 16 18C16 17.9074 16.005 17.8159 16.0148 17.7259L7.18946 13.8428C6.74453 14.2509 6.15136 14.5 5.5 14.5C4.11929 14.5 3 13.3807 3 12C3 10.6193 4.11929 9.5 5.5 9.5C6.15137 9.5 6.74455 9.74911 7.18948 10.1573L16.0149 6.27409C16.005 6.18408 16 6.09263 16 6C16 4.61929 17.1193 3.5 18.5 3.5C19.8807 3.5 21 4.61929 21 6Z"
                        fill={color}
                    />
                </svg>
        );
    };
